<style lang="scss">
body {
    background: white;
    height: 100%;
}
.dy_notice {
    .flex {
        display: flex;
    }

    background: white;
    .site_banner {
        background: url(../../assets/images/dy/all.png) #51b5c8 no-repeat center
            center;
        height: 300px;
        text-align: center;
        width: auto;
        background-position: 0 -1303px;
        line-height: 300px;
        img {
            vertical-align: middle;
        }
    }
    .content {
        width: 1170px;
        margin: 20px auto;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 80px 70px 80px;
        background: white;
        border: 1px solid #f5f5f5;
        box-shadow: -3px 0 10px #ebebeb, 3px 0 10px #ebebeb, 0 -3px 10px #ebebeb,
            0 3px 10px #ebebeb;
        .annoucementForm-header {
            text-align: center;
            font-size: 22px;
            font-weight: 600;
            padding: 10px 0;
        }
        .noticeList {
            li {
                border-bottom: solid 1px #eee;
                padding: 10px 20px;
                line-height: 35px;
                display: flex;
                justify-content: space-between;
                &:last-child {
                    border-bottom: 0;
                }
                .dian {
                    padding-left: 15px;
                    text-align: center;
                    background: url(../../assets/images/dy/all.png);
                    height: 8px;
                    width: 10px;
                    background-position: 0 -1125px;
                    margin-top: 12px;
                }
                .title {
                    overflow: hidden;
                    width: 780px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                a {
                    display: block;
                    width: 100%;
                    color: #333;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>

<template>
    <div class="dy_notice">
        <div class="site_banner">
            <img src="../../assets/images/dy/logo.png">
        </div>
        <div class="content">
            <div class="annoucementForm-box">
                <div class="annoucementForm-header">
                    <span class="text">考试公告</span>
                </div>
                <ul class="noticeList">
                    <template v-for="(testInform,index) in testInforms">
                        <li v-if="index<8">
                            <div class="flex">
                                <div
                                    class="dian"
                                    style="float: left"
                                ></div>
                                <router-link
                                    class="title"
                                    target="_blank"
                                    :to="{name:'default.dynotice',query:{id:testInform.id}}"
                                >
                                    {{testInform.title}}
                                </router-link>
                            </div>
                            <div>{{testInform.create_time}}</div>
                        </li>
                    </template>

                </ul>
            </div>
            <el-pagination
                @size-change="sizeChange"
                @current-change="pageIndexChange"
                :current-page.sync="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                style="float:right;padding-right:50px;padding-top:20px"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            testInforms: [],
            pageIndex: 1,
            pageSize: 10,
            pageSizes: [5, 10, 20, 50],
            total:0
        };
    },
    created: function() {
        this.getData();
    },
    methods: {
        sizeChange: function(pageSize) {
            this.pageSize = pageSize;
            if (this.pageIndex === 1) {
                this.getData();
            } else {
                this.pageIndex = 1;
                this.getData();
            }
        },
        pageIndexChange: function(pageIndex) {
            this.pageIndex = pageIndex;
            this.getData();
        },
        getNormalAnn: function() {
            let url;
            url =
                "ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT";

            this.$http
                .get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: "zhongxintest",
                        page_index: this.pageIndex,
                        page_size: this.pageSize,
                        n_type: "se"
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 1) {
                                this.testInforms = item._items;
                                this.total = item.totalCount;
                                this.pageIndex = item.pageIndex;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        },
        getData() {
            this.getNormalAnn();
        }
    }
};
</script>


